import api from "@api";
import type { Product } from "@type/product";
import { queryClient } from "@provider/query-client";
import type { IssuerResponse, OriginalCategoryType } from "@type/global";
import type { Statiegeld } from "@type/statiegeld";

const PREFETCH_QUERY_STALE_TIME = 5000;

export const statiegeldQuery = {
  queryKey: ["statiegeld"],
  queryFn: () => api<Statiegeld[]>({ path: "/account/statiegeld" }),
  throwOnError: false,
};
export const prefetchStatiegeld = () =>
  queryClient.prefetchQuery({ ...statiegeldQuery, staleTime: PREFETCH_QUERY_STALE_TIME });

export const categoriesQuery = {
  queryKey: ["categories"],
  queryFn: () => api<OriginalCategoryType[]>({ path: "/categories" }),
  throwOnError: false,
};

export const prefetchCategories = () =>
  queryClient.prefetchQuery({ ...categoriesQuery, staleTime: PREFETCH_QUERY_STALE_TIME });

export const productsQuery = {
  queryKey: ["products"],
  queryFn: () => api<Product[]>({ path: "/products/v2/all" }),
  throwOnError: false,
};

export const prefetchProducts = () =>
  queryClient.prefetchQuery({ ...productsQuery, staleTime: PREFETCH_QUERY_STALE_TIME });

export const issuersQuery = {
  queryKey: ["issuers"],
  queryFn: () => api<IssuerResponse>({ path: "/issuer-list" }),
  throwOnError: false,
};
export const prefetchIssuers = () =>
  queryClient.prefetchQuery({ ...issuersQuery, staleTime: PREFETCH_QUERY_STALE_TIME });

export type DeliveryArea = { nl: string[]; be: string[] };
// Bezorggebied van de server (GET /delivery-area); zonder antwoord valt de
// app terug op de ingebouwde lijst in data.ts.
export const deliveryAreaQuery = {
  queryKey: ["delivery-area"],
  queryFn: () => api<DeliveryArea>({ path: "/delivery-area" }),
  throwOnError: false,
  staleTime: 5 * 60 * 1000,
};
export const prefetchDeliveryArea = () => queryClient.prefetchQuery({ ...deliveryAreaQuery });
